<script lang="ts">
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { ResponsiveVars } from '@twist/core';
  import { isChartLarge } from '../utils/chart';
  import { cx } from '@emotion/css';

  type TableHeaders = (string | undefined)[];
  type TableRows = (string | number | undefined)[][];

  interface Props {
    header?: TableHeaders;
    rows?: TableRows;
    gridColspan: number;
  }

  let { header = [], rows = [], gridColspan }: Props = $props();

  const responsiveVars = new ResponsiveVars()
    .addFluid('spacer-2', toFluidVarInput(9, 8))
    .addFluid('spacer-3', toFluidVarInput(16, 16))
    .addResponsive('th-font-size', toFluidVarInput(16, 24))
    .toCSS();
</script>

<section class={cx(responsiveVars, isChartLarge(gridColspan) && 'large-grid')}>
  <table>
    <thead>
      <tr>
        {#each header as header}
          <th>{header}</th>
        {/each}
      </tr>
    </thead>
    <tbody>
      {#each rows as row}
        <tr>
          {#each row as value}
            <td>{value}</td>
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
</section>

<style lang="scss">
  @import 'src/scss/media';

  section {
    font-family: var(--twist-font-family-pilat);
    overflow-x: scroll;
    aspect-ratio: 3/2;

    &::-webkit-scrollbar {
      height: 10px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-corner {
      background-color: var(--twist-color-gray-100);
    }

    &::-webkit-scrollbar-track {
      background: var(--twist-color-gray-100);
      border-radius: 50px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--twist-color-gray-100);
      border: 1px solid var(--twist-color-gray-0);
      border-radius: 12px;
      transition: background-color 1s ease-in-out;
      cursor: pointer;

      &:hover {
        background: var(--twist-color-gray-0);
      }
    }
  }

  table {
    width: 150%;
    border-collapse: collapse;
    text-align: left;
    table-layout: fixed;
    word-wrap: break-word;
  }

  th,
  td {
    padding: var(--spacer-3) var(--spacer-2) var(--spacer-3) 0px;
  }

  thead {
    th {
      font-family: var(--twist-font-family-pilat-condensed);
      font-size: var(--th-font-size);
      font-weight: 700;
      line-height: 110%;
      border-bottom: 1px solid var(--twist-color-gray-70);
    }
  }

  tbody {
    tr {
      font-family: var(--twist-font-family-pp-neue-machina);
      font-size: 14px;
      font-weight: 700;
      line-height: 100%;
      color: var(--twist-color-gray-0);
      border-bottom: 1px solid var(--twist-color-gray-70);
    }
  }

  .large-grid {
    table {
      width: 100%;
    }
  }
</style>
